import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv3020GetResultModel, Inv3020GetResultSchema } from './get.schema'

export async function fetchInv3020(id: number): Promise<Inv3020GetResultModel> {
  const response = await axios.get<Inv3020GetResultModel>(
    `/api/warehouse/inv3020/${id}`
  )
  return Inv3020GetResultSchema.parse(response.data)
}

export const getInv3020ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv3020', id],
    queryFn: () => fetchInv3020(id),
  })
